import { FileText } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { MENU_IMAGES, SITE } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

export const MenuSection = () => {
  const { t } = useLang();
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="py-24 md:py-36 bg-foreground text-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>{t.menu.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5 leading-tight text-background">
              {t.menu.title}
            </h2>
            <p className="mt-6 text-background/60 font-light leading-relaxed max-w-md">
              {t.menu.p}
            </p>
            <p className="mt-4 text-accent text-sm font-light max-w-md">
              {t.menu.note}
            </p>
            <div className="mt-9 flex flex-wrap gap-4">
              <a
                data-testid="menu-pdf"
                href={SITE.menuPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-accent text-accent-foreground text-xs uppercase tracking-luxe px-8 py-4 hover:bg-background hover:text-foreground transition-colors duration-300"
              >
                <FileText size={16} /> {t.common.viewMenu}
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal y={40} className="grid grid-cols-2 gap-3 md:gap-4">
            {MENU_IMAGES.map((src, i) => (
              <img
                key={i}
                src={src}
                alt="Snacks and cocktails from the Tribe Beach Lounge kitchen, Tigaki, Kos"
                className={`w-full object-cover hover:scale-105 transition-transform duration-700 ${
                  i % 2 === 0 ? "h-72 md:h-[460px]" : "h-72 md:h-[460px] mt-0 md:mt-12"
                }`}
              />
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
